import createIcon from '../../createIcon';

/**
 * @component @name UnfoldLessDouble
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNTgwMiAxLjQxTDE1LjE2MDIgMEwxMS45OTAyIDMuMTdMOC44MjAxNiAwTDcuNDEwMTYgMS40MUwxMS45OTAyIDZMMTYuNTgwMiAxLjQxWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE2LjU4MDIgNi40MUwxNS4xNjAyIDVMMTEuOTkwMiA4LjE3TDguODIwMTYgNUw3LjQxMDE2IDYuNDFMMTEuOTkwMiAxMUwxNi41ODAyIDYuNDFaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNNy40MjAxNiAxNy41OUw4Ljg0MDE2IDE5TDEyLjAxMDIgMTUuODNMMTUuMTgwMiAxOUwxNi41OTAyIDE3LjU5TDEyLjAxMDIgMTNMNy40MjAxNiAxNy41OVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik03LjQyMDE2IDIyLjU5TDguODQwMTYgMjRMMTIuMDEwMiAyMC44M0wxNS4xODAyIDI0TDE2LjU5MDIgMjIuNTlMMTIuMDEwMiAxOEw3LjQyMDE2IDIyLjU5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const UnfoldLessDouble = createIcon('UnfoldLessDouble', [
  [
    'path',
    {
      d: 'M16.5802 1.41L15.1602 0L11.9902 3.17L8.82016 0L7.41016 1.41L11.9902 6L16.5802 1.41Z',
      key: 'ksflfv',
    },
  ],
  [
    'path',
    {
      d: 'M16.5802 6.41L15.1602 5L11.9902 8.17L8.82016 5L7.41016 6.41L11.9902 11L16.5802 6.41Z',
      key: 'nj010x',
    },
  ],
  [
    'path',
    {
      d: 'M7.42016 17.59L8.84016 19L12.0102 15.83L15.1802 19L16.5902 17.59L12.0102 13L7.42016 17.59Z',
      key: '1mu4os',
    },
  ],
  [
    'path',
    {
      d: 'M7.42016 22.59L8.84016 24L12.0102 20.83L15.1802 24L16.5902 22.59L12.0102 18L7.42016 22.59Z',
      key: 'wihgok',
    },
  ],
]);

export default UnfoldLessDouble;
